import { useQueryClient } from "@tanstack/react-query"
import { RouterProvider, createRouter } from "@tanstack/react-router"
import { useAuth } from "modules/shared/hooks/useAuth"
import { routeTree } from "./routeTree.gen"

import { useAuthEmployeeQuery } from "modules/auth/hooks/useAuthEmployeeQuery"
import { AuthProvider } from "modules/shared/components/Auth/AuthProvider"

const router = createRouter({
  routeTree,
  defaultPreload: false,
  context: {
    queryClient: undefined!,
    auth: undefined!,
    localUser: undefined!,
  },
  notFoundMode: "root",
})

declare module "@tanstack/react-router" {
  interface Register {
    router: typeof router
  }
}

export function RouterWrapper() {
  return (
    <AuthProvider>
      <Router />
    </AuthProvider>
  )
}

function Router() {
  const auth = useAuth()
  const queryClient = useQueryClient()
  const { data: localUser } = useAuthEmployeeQuery()

  return (
    <RouterProvider
      router={router}
      context={{
        queryClient,
        auth,
        localUser,
      }}
    />
  )
}
